import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, chainStoresActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, chainStoresActions);

export default slice.reducer;
